export default {"src":"/_next/static/media/sailing-together-lg.colour.ed5fa9ce.svg","height":374,"width":524,"blurWidth":0,"blurHeight":0};